import React from "react";
import { useHistory } from "react-router";
import { isMobile } from "../../helperFunc";
import GoogleMapView from "./GoogleMapView";
// import { GoogleMapView } fro/m "../../../../../_components/_warehouse";
import "./style.css";
const MapView = ({
  wh_Arr,
  currentLatLong,
  setCurrentLatLong,
  className,
  showInfoIcon = true,
}) => {
  console.log(currentLatLong,"currentLatLong")
  console.log(wh_Arr, "map data ");
  const history = useHistory();

  //   useEffect(() => {
  //    document.body?.classList.add("padding-top-unset");
  //     commonApiCall();
  //   }, []);
  return (
    <div
      className={`mapAreaMobile ${className}`}
      style={wh_Arr.length === 0 ? { display: "none" } : {}}
    >
      <GoogleMapView
        warehouses={wh_Arr}
        activeMarkerID={""}
        frameProperties={{
          height: "100%",
          src: "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d28022.09171093574!2d77.38984899999998!3d28.606932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1578471958145!5m2!1sen!2sin",
        }}
        currentLatLong={currentLatLong}
        history={history}
        zoomIndex={isMobile ? 3.2 : 5}
        showInfoIcon={showInfoIcon}
      />
    </div>
  );
};
export default MapView;
